<template>
  <div>
    <b-form-group v-bind:label="Datafield.label" v-bind:description="Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" required v-bind:id="'Confirmpassword1'" v-bind:name="Datafield.name" v-bind:placeholder="Datafield.label" v-model="Datadata"></b-form-input>
    </b-input-group>
    </b-form-group>

    <b-form-group v-bind:label="Datafield.label" v-bind:description="Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" @change="validatePassword" required v-bind:id="'Confirmpassword2'" v-bind:name="Datafield.name" v-bind:placeholder="Datafield.label"></b-form-input>
    </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'inputPasswordConfirm',
  props: {
    field: { required: true },
    data: { required: true }
  },
  data: function () {
    return {
      Datafield: {},
      Datadata: '',
      Confirmpassword1: '',
      Confirmpassword2: ''
    }
  },
  mounted () {
    this.Datafield = this.field
    this.Datadata = this.data
  },
  methods: {
    validatePassword: function () {
      let div = document.querySelector('#' + this.form + ' button')
      if (this.Confirmpassword1.value !== this.Confirmpassword2.value) {
        alert('Las constraseñas no coinciden.')
        div.setAttribute('style', 'display:none;')
      } else {
        div.setAttribute('style', 'display:block;')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputPasswordConfirm.vue